var render = function render(){var _vm=this,_c=_vm._self._c;return (typeof _vm.logo !== 'undefined')?_c('span',[(_vm.inCard)?_c('v-card',[_c('v-img',{attrs:{"src":`${_vm.publicPath}img/${_vm.logo}`}})],1):_c('v-img',{staticClass:"mx-8",attrs:{"src":`${_vm.publicPath}img/${_vm.logo}`}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }